/**
 * Alpine.js Album Details Editor Component
 * Handles the modal form for editing album title, description, location, and ACL settings
 */

/**
 * Creates an album details editor component
 * @param {Object} config - Initial configuration
 * @param {string} config.title - Album title
 * @param {string} config.description - Album description
 * @param {string} config.location - Album location
 * @param {number} config.viewAcl - View ACL level
 * @param {number} config.commentAcl - Comment ACL level
 * @param {string} config.saveUrl - URL to POST form data
 */
export function albumDetailsEditor(config = {}) {
    return {
        showEditModal: false,
        title: config.title ?? '',
        description: config.description ?? '',
        location: config.location ?? '',
        view_acl: config.viewAcl ?? 0,
        comment_acl: config.commentAcl || 1,
        saveUrl: config.saveUrl ?? '',
        saving: false,
        error: null,
        viewAclOpen: false,
        commentAclOpen: false,
        viewAclLabels: config.viewAclLabels ?? {},
        commentAclLabels: config.commentAclLabels ?? {},

        async save() {
            this.saving = true;
            this.error = null;

            try {
                const formData = new FormData();
                formData.append('title', this.title);
                formData.append('description', this.description);
                formData.append('location', this.location);
                formData.append('view_acl', this.view_acl);
                formData.append('comment_acl', this.comment_acl);

                const csrfToken = document.querySelector('meta[name=csrf-token]')?.content || '';
                formData.append('csrf_token', csrfToken);

                const response = await fetch(this.saveUrl, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                const data = await response.json();

                if (data.success) {
                    window.location.reload();
                } else if (data.error) {
                    this.error = data.error;
                } else {
                    this.error = 'Failed to save changes. Please try again.';
                }
            } catch (e) {
                this.error = 'An error occurred. Please try again.';
            } finally {
                this.saving = false;
            }
        }
    };
}
